import React , {useEffect} from "react";
import Sidebar from "../common/Sidebar";
import Logout from "../common/Logout";

const Dashboard = () => {
  useEffect(() => {
    document.title = "Dashboard"
    window.scrollTo(0,0);
  },[])
  return (
    <>
      <div className="main_section">
        <div className="main_flex">
          <div className="main_flexL">
            <Sidebar />
          </div>
          <div className="main_flexR">
            <div className="right_title">
              <h1>Dashboard</h1>
              <Logout/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
